import { createClient } from 'nhost-js-sdk';

const config = {
  baseURL: process.env.NEXT_PUBLIC_NHOST_BACKEND_URL ?? 'http://localhost:9001',
  autoLogin: process.env.STORYBOOK ? false : true,
};
const { auth, storage } = createClient(config);

export { auth, storage };
